import { Badge } from 'antd'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Routing, { MenuItem, SideMenu } from '../../components/reusable/routing'

import { useInventory, useReports, useLatestPathname } from '../../modules'

import LabQueue from './Queue'

const storeName = "Lab Store"

let menu = [
    {
        path: 'queue',
        title: 'Queue',
        component: LabQueue
    }
]

const Laboratory = () => {
    const history = useHistory()
    const { user } = useSelector(state => state.application)
    const pathname = useLatestPathname()

    const [Inventory, store, requests] = useInventory(storeName)

    const [Reports, reports] = useReports("lab")

    useEffect(() => {
        if (user.stores.some(st => st.name === storeName) || user?.issuperuser)
            menu[1] = {
                path: 'inventory',
                title: props => 
                    <Badge className='w-12' count={ requests }>
                        <MenuItem condition={ props?.condition }>Inventory</MenuItem>
                    </Badge>,
                component: ({ path }) => <Inventory path={ path } storeName={ storeName } />
            }

        
        menu[2] = {
            path: 'reports',
            title: 'Reports',
            component: () => <Reports reports={ reports } department="nursing" />
        }

        const target = `/app/lab/${menu[0].path}`
        if (!pathname.current.startsWith(target)) history.push(target)
    }, [store, user, reports])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Laboratory</p>
                <SideMenu namespace="lab" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="lab" menu={ menu } />
            </div>
        </div>
    )
}

export default Laboratory